import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";

import { Layout, GlobalErrorElement } from "@/components/layout";
import { HomePage } from "@/features/dashboard/pages/HomePage";
import { OrdersPage, TrackOrderPage } from "@/features/orders";
import { ProductsPage, ProductDetailPage } from "@/features/products";
import { DesignersPage, DesignerDetailPage } from "@/features/designers";
import { CustomOrdersPage } from "@/features/custom-orders";
import { AboutPage, ContactPage } from "@/features/marketing";

import { ROUTES } from "./paths";

/**
 * Every route is public: there are no accounts. A placed order is protected by
 * the unguessable token in its URL, not by a route guard.
 */
export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      errorElement={
        <GlobalErrorElement
          error={new Error("Page Not Found")}
          resetErrorBoundary={() => {}}
        />
      }
    >
      <Route
        element={
          <ErrorBoundary FallbackComponent={GlobalErrorElement}>
            <Layout />
          </ErrorBoundary>
        }
      >
        <Route path={ROUTES.HOME} element={<HomePage />} />
        <Route path={ROUTES.PRODUCTS} element={<ProductsPage />} />
        <Route path={ROUTES.PRODUCT_DETAIL()} element={<ProductDetailPage />} />
        <Route path={ROUTES.DESIGNERS} element={<DesignersPage />} />
        <Route path={ROUTES.DESIGNER_DETAIL()} element={<DesignerDetailPage />} />
        <Route path={ROUTES.CUSTOM_ORDERS} element={<CustomOrdersPage />} />
        <Route path={ROUTES.ORDERS} element={<OrdersPage />} />
        <Route path={ROUTES.TRACK()} element={<TrackOrderPage />} />
        <Route path={ROUTES.TRACK_CUSTOM()} element={<TrackOrderPage custom />} />
        <Route path={ROUTES.ABOUT} element={<AboutPage />} />
        <Route path={ROUTES.CONTACT} element={<ContactPage />} />
      </Route>
    </Route>
  )
);

export default router;
